import { j as jsxRuntimeExports } from './../../../../ext/react/jsx-runtime.js';
import { ReferralCardBase } from './Base/ReferralCardBase.js';

const ReferralCard = ({ variant = 'base', ...props }) => {
    switch (variant) {
        case 'base':
            return jsxRuntimeExports.jsx(ReferralCardBase, { ...props });
        default:
            return jsxRuntimeExports.jsx(ReferralCardBase, { ...props });
    }
};

export { ReferralCard };
//# sourceMappingURL=ReferralCard.js.map
